import { pushDataLayer } from "../../../Shared/utils/datalayer";
import { inspirationLabelsWeb } from "./Inspiration/Shared/InspirationBaseSelector";
export const pushAanZetDataLayer = (data)=>pushDataLayer({
        ...data,
        event: 'aanzet-event'
    });
export const pushLocationEvent = (d)=>pushDataLayer({
        event: 'aanzet-event',
        category: 'Location',
        ...d
    });
export const pushExpand = (label)=>pushAanZetDataLayer({
        category: 'Location',
        action: 'Unfold',
        label: label
    });
export const pushTag = (action)=>pushAanZetDataLayer({
        category: 'Activity tag',
        action,
        label: window.location.pathname
    });
export const pushMembership = (membershipCategory, label)=>pushAanZetDataLayer({
        category: `Lidmaatschap ${membershipCategory.toLocaleLowerCase()}`,
        action: "lidmaatschap-" + label.toLowerCase(),
        label: ""
    });
export const pushMainMenu = (label)=>pushAanZetDataLayer({
        category: 'Hoofdmenu',
        action: 'hoofdmenu-' + label.toLowerCase().split(' ').join(''),
        label: label
    });
export const pushSecondaryMenu = (label)=>pushAanZetDataLayer({
        category: "Secundair menu",
        action: 'secundairmenu-' + label.toLowerCase().split(' ').join(''),
        label: label
    });
export const pushVenueMembership = ()=>pushAanZetDataLayer({
        category: "Vestigingspagina per stad",
        action: 'bekijk-abonnement',
        label: 'Openklapper lid worden'
    });
export const pushFooterMembership = ()=>pushAanZetDataLayer({
        category: "Footer",
        action: "footer-wordlid",
        label: "Lid worden"
    });
export const pushMobileMainMenu = (label)=>pushAanZetDataLayer({
        category: "Mobiel hoofdmenu",
        action: 'menu-mobiel-' + label.toLowerCase().split(' ').join(''),
        label: label
    });
export const pushMobileSecondaryMenu = (label)=>pushAanZetDataLayer({
        category: "Mobiel secundair menu",
        action: 'secundairmenu-mobiel-' + label.toLowerCase().split(' ').join(''),
        label: label
    });
export const pushActivityFilter = (filter, label)=>pushAanZetDataLayer({
        category: 'Activiteiten',
        action: `activiteiten-filter-${filter}`,
        label: `${filter} - ${label}`
    });
export const pushActivitySearch = (query)=>pushAanZetDataLayer({
        category: 'Activiteiten',
        action: `activiteiten-filter-text`,
        label: `${query.trim().toLowerCase().replace(/\s+/g, ' ')}`
    });
export const pushCtaBlockAction = (title, type, label)=>pushAanZetDataLayer({
        category: `CTA: ${title}`,
        action: `cta-action-${type}`,
        label: label
    });
export const pushInspirationAction = (collection, action, label)=>pushDataLayer({
        event: 'AanZet Inspiratie',
        category: inspirationLabelsWeb[collection],
        action,
        label
    });
export const pushThemeBasedInspirationAction = function(action) {
    let label = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return pushInspirationAction('theme', action, label);
};
export const pushMoodBasedInspirationAction = function(action) {
    let label = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return pushInspirationAction('mood', action, label);
};
export const pushBookBasedInspirationAction = function(action) {
    let label = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return pushInspirationAction('book', action, label);
};
export const pushLocationBasedInspirationAction = function(action) {
    let label = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return pushInspirationAction('location', action, label);
};
export const pushBuildingBlockAction = (clickText)=>pushAanZetDataLayer({
        category: 'Bouwblok',
        action: window.location.pathname,
        label: clickText
    });
export const pushLocationSelectionAction = (location)=>pushAanZetDataLayer({
        category: "Localization",
        action: "select-prefered-location",
        label: location
    });
